import { getBackendUri } from '../utils/EnvConfigUtils';
import FetchUtils, { parseJSON } from './fetch_utils';
import { logoutSuccess } from '../actions/session_actions';

const fetchUtils = new FetchUtils();
const baseUrl = getBackendUri();

const fetchLifecycleAnalyticsKPI =
	(apiSubstring) =>
	(userType) =>
	(params = {}, filters = null, pagination = null, sorting = null) => {
		let queryParams = Object.assign({}, params);

		if (pagination) {
			const paginationQuery = {
				offset: (pagination.current - 1) * pagination.pageSize,
				limit: pagination.pageSize,
			};
			queryParams = {
				...queryParams,
				...paginationQuery,
			};
		}

		if (sorting) {
			const sortingQuery = { ...sorting, order: sorting.order === 'ascend' ? 'asc' : 'desc' };
			queryParams = {
				...queryParams,
				...sortingQuery,
			};
		}

		if (filters) {
			queryParams = {
				...queryParams,
				...filters,
			};
		}

		const queryUri = baseUrl + `/api/v1/${userType}/kpi/lifecycle_analytics/${apiSubstring}`;

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.get(
						queryUri,
						Object.assign(
							{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
							queryParams
						)
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (!ok || d.status === 'error') {
							reject(d.message);
						} else {
							resolve(d.data || []);
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};

export const fetchLifecyclePrioritySummary = fetchLifecycleAnalyticsKPI('priority_summary');
export const fetchLifecycleSupplierPerformance = fetchLifecycleAnalyticsKPI('supplier_performance');
export const fetchLifecycleMonthlyApprovalTime =
	fetchLifecycleAnalyticsKPI('monthly_approval_time');
export const fetchLifecycleMonthlyResponseTime =
	fetchLifecycleAnalyticsKPI('monthly_response_time');
export const fetchLifecycleMonthlyResolutionTime =
	fetchLifecycleAnalyticsKPI('monthly_resolution_time');
export const fetchLifecycleMonthlyFirstTimeFixRate = fetchLifecycleAnalyticsKPI(
	'monthly_first_time_fix_rate'
);
export const fetchLifecycleMonthlySpend = fetchLifecycleAnalyticsKPI('monthly_spend');
